module.exports = {
      id: "trending-usage",
      viewBox: "0 0 27.001 27.001",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#trending",
      toString: function () {
        return this.url;
      }
    }